import { useEffect, useState } from "react";
import Table from "../Table";
import Card from "./Card";
import api from "../../api";
import { formatPrice, formatDateV2, formatTimeV2 } from "../../utils";
import Button from "../Button";
import { Link, useNavigate } from "react-router-dom";
import TooltipWrapper from "../TooltipWrapper";
import { addDays } from "date-fns";
import Pagination from "../Pagination";
import styles from "./OrdersCard.module.css";

const OrdersCard = ({ modern = false }) => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(0);
    const [sales, setSales] = useState([]);

    const getSales = async () => {
        setLoading(true);
        setError(false);
        try {

            const params = new URLSearchParams();

            params.append("start_date", addDays(new Date(), -7).toISOString());

            params.append("end_date", new Date().toISOString());

            params.append("test", false);


            const stats = await api.get(`/admin/reports/sales/transactions?${params.toString()}`,)
            setSales(stats)
        }
        catch (error) {
            console.error(error);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { 
        getSales();
    }, []);


    const completed = sales.filter(sale => sale.status === "succeeded").sort((a, b) => new Date(b.date) - new Date(a.date));
    if (modern) return (
        <Card appearance="modern" title="Transazioni completate" actions={<Button appearance="subtle" onClick={() => navigate('/orders')}>Vedi ordini</Button>}>
            <div className={styles.summary}><span>Ultimi 7 giorni</span><span>{loading ? 'Caricamento…' : `${completed.length} transazioni`}</span></div>
            {error ? <div className={styles.empty} role="alert">Impossibile caricare le transazioni.<Button appearance="subtle" onClick={getSales}>Riprova</Button></div> : loading ? <div className={styles.empty} role="status">Caricamento delle transazioni…</div> : completed.length === 0 ? <p className={styles.empty}>Nessuna transazione completata negli ultimi 7 giorni.</p> : <>
                <ul className={styles.transactions}>
                    {completed.slice(page * 4, (page + 1) * 4).map((sale, index) => <li key={`${sale.order_id}-${sale.date}-${index}`}>
                        <Link to={`/orders/${sale.order_id}`} className={styles.transaction}>
                            <div className={styles.row}><strong className={styles.customer}>{sale.user_name || 'Cliente'}</strong><strong className={styles.amount}>{formatPrice(sale.amount)} €</strong></div>
                            <span className={styles.product} title={sale.product_name}>{sale.product_name || 'Ordine'}</span>
                            <div className={styles.metadata}><span>#{sale.order_no || sale.order_id}</span><time dateTime={sale.date}>{formatDateV2(sale.date, { day: 'numeric', month: 'short' })} · {formatTimeV2(sale.date)}</time></div>
                        </Link>
                    </li>)}
                </ul>
                <div className={styles.footer}><Pagination total={completed.length} per={4} page={page} group={0} onChange={setPage} /></div>
            </>}
        </Card>
    );

    return (
        <Card noPadding appearance={modern ? "modern" : undefined} actions={<Button appearance="subtle" onClick={() => navigate('/orders')}>Vedi ordini</Button>} style={{ flex: 1 }} title={modern ? "Transazioni completate · 7 giorni" : "ULTIME TRANSAZIONI COMPLETATE"}>
            {!modern && <Button appearance="subtle" style={{ position: 'absolute', top: '0.875rem', right: '0.875rem' }} onClick={() => {
                navigate("/orders")
            }}>VEDI TUTTI</Button>}
            <div style={{ display: 'flex', overflow: 'auto', height: modern ? '400px' : '550px' }}>
                <Table
                    appearance={modern ? "minimal" : undefined}
                    style={{ borderRadius: 0 }}
                    loadingN={10}
                    columns={[
                        { key: "user", label: "UTENTE", type: "string", wrap: true },
                        { key: "amount", label: "TOTALE", type: "custom" },
                        { key: "date", label: "DATA", type: "datetime", options: { day: 'numeric', month: 'short' }, forceNumeric: false },
                    ]}
                    elements={sales.filter(s => s.status === "succeeded").map((sale) => ({
                        id: sale.order_id,
                        order_no: sale.order_no,
                        user: sale.user_name,
                        amount: {
                            value: sale.amount, type: "number", component:
                                <TooltipWrapper text={sale.product_name}>
                                    <div>
                                        € {formatPrice(sale.amount)}
                                    </div>
                                </TooltipWrapper>
                        },
                        date: sale.date,
                        href: `/orders/${sale.order_id}`
                    }))}
                    loading={loading}
                />
            </div>
        </Card>
    )
}

export default OrdersCard
